export default __webpack_public_path__ + "static/media/September2011.6b188e08.png";